import React from "react";
import { Typography, useTheme } from "@mui/material";

/**
 * PerlBodyText Component
 *
 * Reusable body text typography for displaying values and content
 * Used for showing selected values like product name, weight, etc.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The text content
 * @param {object} [props.sx] - Additional MUI sx props for customization
 */
const PerlLabelMedium = ({ children, sx = {} }) => {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {};

  return (
    <Typography
      variant="body2"
      sx={{
        color: perlColors.textSecondary,
        fontWeight: 600,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default PerlLabelMedium;
